<div>
  <div
    class="nav-bar-container"
    [class.collapsed]="isCollapsed"
    [class.expanded]="!isCollapsed"
  >
    <div class="nav-logo-container" *ngIf="!isCollapsed">
      <img
        src="../../../../assets/Logos/ALG_ALM_Logo_RGB_5830x2158px_Orange.svg"
        alt="Logo"
      />
    </div>
    <div
      class="hamburger-icon"
      *ngIf="!isCollapsed"
      (click)="toggleMobileMenu()"
    >
      <mat-icon>menu</mat-icon>
    </div>
    <div class="collapsed-logo" *ngIf="isCollapsed">
      <img
        src="../../../../assets/Logos/collapsedALM.png"
        alt="Logo"
        width="70px"
        height="auto"
      />
    </div>
    <div class="mobile-sidebar" [ngClass]="{ open: isMobileMenuOpen }">
      <div class="close-button" (click)="closeMobileMenu()">
        <mat-icon>close</mat-icon>
      </div>

      <div class="mobile-nav-icon-container">
        <div
          class="nav-item"
          [routerLink]="['landing']"
          (click)="closeMobileMenu()"
          routerLinkActive="active"
          *ngIf="showDashboardAndProducts"
        >
          <mat-icon class="nav-icons">home</mat-icon>
          <span class="nav-item-label mat-h2">Dashboard</span>
        </div>
        <div
          class="nav-item"
          (keydown)="handleKeyDown($event, 'products')"
          (click)="toggleSubMenu('products')"
          *ngIf="showDashboardAndProducts"
        >
          <mat-icon class="nav-icons">token</mat-icon>
          <span class="nav-item-label mat-h2">Products</span>
          <mat-icon class="nav-arrow">{{
            subMenus.products ? "arrow_drop_up" : "arrow_drop_down"
          }}</mat-icon>
        </div>
        <div *ngIf="subMenus['products']" class="submenu">
          <a [routerLink]="['credential-library']" (click)="closeMobileMenu()"
            >Credential Library</a
          >
        </div>

        <!-- Subscriptions with submenu for regular users (mobile) -->
        <div
          *ngIf="showDashboardAndProducts"
          class="nav-item"
          (keydown)="handleKeyDown($event, 'subscriptions')"
          (click)="toggleSubMenu('subscriptions')"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
          <span class="nav-item-label mat-h2">Subscriptions</span>
          <mat-icon class="nav-arrow">{{
            subMenus.subscriptions ? "arrow_drop_up" : "arrow_drop_down"
          }}</mat-icon>
        </div>
        <div *ngIf="subMenus['subscriptions'] && showDashboardAndProducts" class="submenu">
          <a [routerLink]="['all-subscriptions']" (click)="closeMobileMenu()"
            >Active Subscriptions</a
          >
        </div>

        <!-- Subscriptions direct link for Zentra admins (mobile) -->
        <div
          *ngIf="!showDashboardAndProducts && !showDashboardAndProductsOvertur && !showSATAdmin"
          class="nav-item"
          [routerLink]="['zentra-subscriptions']"
          (click)="closeMobileMenu()"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
          <span class="nav-item-label mat-h2">Subscriptions</span>
        </div>

        <!-- Subscriptions direct link for SAT admins (mobile) -->
        <div
          *ngIf="showSATAdmin"
          class="nav-item"
          [routerLink]="['sat-subscriptions']"
          (click)="closeMobileMenu()"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
          <span class="nav-item-label mat-h2">Subscriptions</span>
        </div>

        <!-- Subscriptions direct link for Overtur admins (mobile) -->
        <div
          *ngIf="showDashboardAndProductsOvertur"
          class="nav-item"
          [routerLink]="['overtur-admin-subscriptions']"
          (click)="closeMobileMenu()"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
          <span class="nav-item-label mat-h2">Subscriptions</span>
        </div>

        <div
          class="nav-item"
          (keydown)="handleKeyDown($event, 'onboardingItems')"
          (click)="toggleSubMenu('onboardingItems')"
          *ifPermissions="['Internal Admin']"
        >
          <mat-icon class="nav-icons">library_add</mat-icon>
          <span class="nav-item-label mat-h2">Onboarding</span>
          <mat-icon class="nav-arrow">{{
            subMenus.onboardingItems ? "arrow_drop_up" : "arrow_drop_down"
          }}</mat-icon>
        </div>
        <div *ngIf="subMenus['onboardingItems']" class="submenu">
          <a [routerLink]="['onboarding-form']" (click)="closeMobileMenu()"
            >Onboarding Form</a
          >
          <a [routerLink]="['onboarding-list']" (click)="closeMobileMenu()"
            >Onboarding List</a
          >
        </div>
        <div
          class="nav-item"
          *ngIf="isZentraWholesaler"
          [routerLink]="['/partner-mgmt']"
          (click)="closeMobileMenu()"
        >
          <mat-icon class="nav-icons">groups</mat-icon>
          <span class="nav-item-label mat-h2">Partner Mgmt</span>
        </div>
        <div
          class="nav-item"
          [routerLink]="['support-ticket']"
          (click)="closeMobileMenu()"
        >
          <mat-icon class="nav-icons">help_center</mat-icon>
          <span class="nav-item-label mat-h2">Support</span>
        </div>
      </div>

      <div class="user-profile" [matMenuTriggerFor]="mobileProfileMenu">
        <ng-container *ngIf="userProfile?.picture; else noPictureMobile">
          <img [src]="userProfile!.picture" alt="user" class="round-image" />
        </ng-container>
        <ng-template #noPictureMobile>
          <mat-icon class="user-icon">account_circle</mat-icon>
        </ng-template>
        <div class="user-info1">
          <span class="nav-item-label mat-h2">{{
            userProfile?.given_name
          }}</span>
          <span class="nav-item-label1 mat-h2">{{
            userProfile?.family_name
          }}</span>
        </div>
      </div>

      <mat-menu #mobileProfileMenu="matMenu">
        <div class="menu-header">
          <img
            [src]="userProfile?.picture"
            class="menu-profile-picture"
            alt="Profile"
          />
          <div class="user-info">
            <div>{{ userProfile?.name }}</div>
            <div>{{ userProfile?.email }}</div>
          </div>
        </div>

        <button
          mat-menu-item
          (click)="openThirdPartyNotice()"
          class="thirdparty-button"
        >
          Third Party Notice
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span class="logout-button">Logout</span>
        </button>
      </mat-menu>
    </div>
    <hr class="nav-divider" />
    <div class="nav-icon-container">
      <ng-container *ngIf="isCollapsed">
        <div
          *ngIf="showDashboardAndProducts"
          class="nav-item"
          [routerLink]="['landing']"
          matTooltip="Dashboard"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">home</mat-icon>
        </div>
        <div
          *ngIf="showDashboardAndProducts"
          class="nav-item"
          matTooltip="Products"
          (click)="toggleSubMenu('products')"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">token</mat-icon>
        </div>

        <!-- Subscriptions with submenu for regular users (collapsed) -->
        <div
          *ngIf="showDashboardAndProducts"
          class="nav-item"
          matTooltip="Subscriptions"
          (click)="toggleSubMenu('subscriptions')"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
        </div>

        <!-- Subscriptions direct link for Zentra admins (collapsed) -->
        <div
          *ngIf="!showDashboardAndProducts && !showDashboardAndProductsOvertur && !showSATAdmin"
          class="nav-item"
          matTooltip="Subscriptions"
          [routerLink]="['zentra-subscriptions']"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
        </div>

        <!-- Subscriptions direct link for SAT admins (collapsed) -->
        <div
          *ngIf="showSATAdmin"
          class="nav-item"
          matTooltip="Subscriptions"
          [routerLink]="['sat-subscriptions']"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
        </div>

        <!-- Subscriptions direct link for Overtur admins (collapsed) -->
        <div
          *ngIf="showDashboardAndProductsOvertur"
          class="nav-item"
          matTooltip="Subscriptions"
          [routerLink]="['overtur-admin-subscriptions']"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
        </div>

        <div
          class="nav-item"
          matTooltip="Onboarding"
          (click)="toggleSubMenu('onboardingItems')"
          *ifPermissions="['Internal Admin']"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">library_add</mat-icon>
        </div>
        <div
          *ngIf="isZentraWholesaler"
          class="nav-item"
          matTooltip="Partner Mgmt"
          routerLinkActive="active"
          [routerLink]="['/partner-mgmt']"
        >
          <mat-icon class="nav-icons">groups</mat-icon>
        </div>
        <div
          class="nav-item"
          [routerLink]="['support-ticket']"
          matTooltip="Support"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">help_center</mat-icon>
        </div>
      </ng-container>
      <ng-container *ngIf="!isCollapsed">
        <div
          class="nav-item"
          [routerLink]="['landing']"
          *ngIf="showDashboardAndProducts"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">home</mat-icon>
          <span class="nav-item-label mat-h4">Dashboard</span>
        </div>
        <div
          class="nav-item"
          (keydown)="handleKeyDown($event, 'products')"
          (click)="toggleSubMenu('products')"
          *ngIf="showDashboardAndProducts"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">token</mat-icon>
          <span class="nav-item-label mat-h4">Products</span>
          <mat-icon class="nav-arrow">{{
            subMenus.products ? "arrow_drop_up" : "arrow_drop_down"
          }}</mat-icon>
        </div>
        <div *ngIf="subMenus['products']" class="submenu">
          <a [routerLink]="['credential-library']" routerLinkActive="active"
            >Credential Library</a
          >
        </div>

        <!-- Subscriptions with submenu for regular users -->
        <div
          *ngIf="showDashboardAndProducts"
          class="nav-item"
          (keydown)="handleKeyDown($event, 'subscriptions')"
          (click)="toggleSubMenu('subscriptions')"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
          <span class="nav-item-label mat-h4">Subscriptions</span>
          <mat-icon class="nav-arrow">{{
            subMenus.subscriptions ? "arrow_drop_up" : "arrow_drop_down"
          }}</mat-icon>
        </div>
        <div *ngIf="subMenus['subscriptions'] && showDashboardAndProducts" class="submenu">
          <a
            [routerLink]="['all-subscriptions']"
            (click)="closeMobileMenu()"
            routerLinkActive="active"
            >Active Subscriptions</a
          >
        </div>

        <!-- Subscriptions direct link for Zentra admins -->
        <div
          *ngIf="!showDashboardAndProducts && !showDashboardAndProductsOvertur && !showSATAdmin"
          class="nav-item"
          [routerLink]="['zentra-subscriptions']"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
          <span class="nav-item-label mat-h4">Subscriptions</span>
        </div>

        <!-- Subscriptions direct link for SAT admins -->
        <div
          *ngIf="showSATAdmin"
          class="nav-item"
          [routerLink]="['sat-subscriptions']"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
          <span class="nav-item-label mat-h4">Subscriptions</span>
        </div>

        <!-- Subscriptions direct link for Overtur admins -->
        <div
          *ngIf="showDashboardAndProductsOvertur"
          class="nav-item"
          [routerLink]="['overtur-admin-subscriptions']"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">subscriptions</mat-icon>
          <span class="nav-item-label mat-h4">Subscriptions</span>
        </div>

        <div
          class="nav-item"
          *ifPermissions="['Internal Admin']"
          (keydown)="handleKeyDown($event, 'onboardingItems')"
          (click)="toggleSubMenu('onboardingItems')"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">library_add</mat-icon>
          <span class="nav-item-label mat-h4">Onboarding</span>
          <mat-icon class="nav-arrow">{{
            subMenus.onboardingItems ? "arrow_drop_up" : "arrow_drop_down"
          }}</mat-icon>
        </div>
        <div *ngIf="subMenus['onboardingItems']" class="submenu">
          <a [routerLink]="['onboarding-form']" routerLinkActive="active"
            >Onboarding Form</a
          >
          <a [routerLink]="['onboarding-list']" routerLinkActive="active"
            >Onboarding List</a
          >
        </div>
        <div
          class="nav-item"
          routerLinkActive="active"
          *ngIf="isZentraWholesaler"
          [routerLink]="['/partner-mgmt']"
        >
          <mat-icon class="nav-icons">groups</mat-icon>
          <span class="nav-item-label mat-h4">Partner Mgmt</span>
        </div>
        <div
          class="nav-item"
          [routerLink]="['support-ticket']"
          routerLinkActive="active"
        >
          <mat-icon class="nav-icons">help_center</mat-icon>
          <span class="nav-item-label mat-h4">Support</span>
        </div>
      </ng-container>
    </div>
    <div class="lower-nav">
      <div class="nav-item" (click)="toggleCollapse()">
        <mat-icon class="nav-icons">
          {{ isCollapsed ? "arrow_forward" : "arrow_back" }}
        </mat-icon>
        <span class="nav-item-label mat-h4" *ngIf="!isCollapsed">Collapse</span>
      </div>
      <hr class="nav-divider" />
      <div>
        <div class="nav-item user-profile" [matMenuTriggerFor]="profileMenu">
          <ng-container *ngIf="userProfile?.picture; else noPicture">
            <img [src]="userProfile!.picture" alt="user" class="round-image" />
          </ng-container>
          <ng-template #noPicture>
            <mat-icon class="user-icon">account_circle</mat-icon>
          </ng-template>
          <div
            class="user-info1"
            [class.stack-name]="shouldStackName()"
            *ngIf="!isCollapsed"
          >
            <span class="nav-item-label mat-h4">{{
              userProfile?.given_name
            }}</span>
            <span class="nav-item-label1 mat-h4">{{
              userProfile?.family_name
            }}</span>
          </div>
        </div>
      </div>

      <mat-menu #profileMenu="matMenu">
        <div class="menu-header">
          <img
            [src]="userProfile?.picture"
            class="menu-profile-picture"
            alt="Profile"
          />
          <div class="user-info">
            <div>{{ userProfile?.name }}</div>
            <div>{{ userProfile?.email }}</div>
          </div>
        </div>
        <button
          mat-menu-item
          (click)="openThirdPartyNotice()"
          class="thirdparty-button"
        >
          Third Party Notice
        </button>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span class="logout-button">Logout</span>
        </button>
      </mat-menu>
    </div>
  </div>
</div>
